import React, { useState } from 'react';
import { APIKeyList } from '../components/api-keys/APIKeyList';
import { APIKeyStats } from '../components/api-keys/APIKeyStats';
import { APIKeyDocumentation } from '../components/api-keys/APIKeyDocumentation';
import { PageHeader } from '../components/ui/PageHeader';

export const APIKeyManagementPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'keys' | 'stats' | 'docs'>('keys');

  const tabs = [
    { id: 'keys', name: 'API Keys', icon: '🔑' },
    { id: 'stats', name: 'Statistics', icon: '📊' },
    { id: 'docs', name: 'Documentation', icon: '📚' }
  ] as const;

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <PageHeader
          title="API Key Management"
          subtitle="Create and manage API keys to access the IntFinder platform programmatically."
          align="center"
        />

        {/* Tab Navigation */}
        <div className="border-b border-gray-200 dark:border-gray-700 mb-8 overflow-x-auto custom-scrollbar">
          <nav className="-mb-px flex space-x-6 sm:space-x-8 min-w-max">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`py-3 px-1 border-b-2 font-medium text-sm transition-colors whitespace-nowrap ${
                  activeTab === tab.id
                    ? 'border-indigo-600 text-indigo-600 dark:text-indigo-400 font-semibold'
                    : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:border-gray-300 dark:hover:border-gray-500'
                }`}
              >
                <span className="mr-2">{tab.icon}</span>
                {tab.name}
              </button>
            ))}
          </nav>
        </div>

        {/* Tab Content */}
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow border border-gray-200 dark:border-gray-700">
          {activeTab === 'keys' && (
            <div className="p-6">
              <APIKeyList />
            </div>
          )}
          
          {activeTab === 'stats' && (
            <div className="p-6">
              <APIKeyStats />
            </div>
          )}
          
          {activeTab === 'docs' && (
            <div className="p-6">
              <APIKeyDocumentation />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
